export default __webpack_public_path__ + "static/media/Boots of the Whispering Blade.f1b51a8b.jpg";